document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
menuButton?.addEventListener('click', () => {
  const open = mobileMenu.classList.toggle('is-open');
  menuButton.setAttribute('aria-expanded', String(open));
});

const siteHeader = document.querySelector('[data-header]');
const siteHeaderShell = siteHeader?.closest('.shopify-section');
siteHeaderShell?.classList.add('site-header-shell');
const updateStickyHeader = () => {
  siteHeader?.classList.toggle('is-scrolled', window.scrollY > 12);
};
window.addEventListener('scroll', updateStickyHeader, { passive: true });
updateStickyHeader();

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { rootMargin: '0px 0px -35px' });
document.querySelectorAll('.reveal').forEach((element) => revealObserver.observe(element));

const visibleCartItemCount = (cart) => (cart?.items || []).reduce((count, item) => {
  if (item?.properties?.['الخدمة'] === 'غسيل') return count;
  return count + Number(item.quantity || 0);
}, 0);

document.querySelectorAll('[data-quick-add]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('cart');
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((element) => element.textContent = visibleCartItemCount(cart));
      showToast('تمت إضافة المنتج إلى السلة');
    } catch (error) {
      showToast('تعذر الإضافة. حاول مرة أخرى.');
    } finally {
      button.disabled = false;
    }
  });
});

function showToast(message) {
  const toast = document.querySelector('[data-cart-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
}

document.querySelector('[data-sort-by]')?.addEventListener('change', (event) => {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  window.location.href = url.toString();
});

document.querySelectorAll('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
  const input = button.parentElement.querySelector('input');
  input.value = Math.max(1, Number(input.value) - 1);
  input.dispatchEvent(new Event('change', { bubbles: true }));
}));
document.querySelectorAll('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
  const input = button.parentElement.querySelector('input');
  input.value = Number(input.value) + 1;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}));

const syncWashServiceQuantities = () => {
  const productInputs = [...document.querySelectorAll('[data-wash-product-qty]')];
  document.querySelectorAll('[data-wash-service-qty]').forEach((serviceInput) => {
    const washLink = serviceInput.dataset.washLink || '';
    let matches = [];
    if (washLink) {
      matches = productInputs.filter((input) => input.dataset.washLink === washLink);
    } else {
      const productTitle = serviceInput.dataset.washFor || '';
      matches = productInputs.filter((input) => input.dataset.washTitle === productTitle);
    }
    if (matches.length === 1) serviceInput.value = matches[0].value;
  });
};
document.querySelectorAll('[data-wash-product-qty]').forEach((input) => input.addEventListener('change', syncWashServiceQuantities));
document.querySelector('#CartForm')?.addEventListener('submit', syncWashServiceQuantities);
syncWashServiceQuantities();

document.querySelectorAll('[data-wash-remove]').forEach((link) => link.addEventListener('click', async (event) => {
  event.preventDefault();
  const productKey = link.dataset.productKey;
  const serviceKey = link.dataset.serviceKey;
  if (!productKey || !serviceKey) {
    window.location.href = link.href;
    return;
  }
  link.style.pointerEvents = 'none';
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: { [productKey]: 0, [serviceKey]: 0 } })
    });
    if (!response.ok) throw new Error('cart');
    window.location.reload();
  } catch (error) {
    link.style.pointerEvents = '';
    showToast('تعذر حذف المنتج. حاول مرة أخرى.');
  }
}));

document.querySelectorAll('[data-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
  const panel = document.querySelector('[data-filter-panel]');
  const open = panel?.classList.toggle('is-open');
  button.setAttribute('aria-expanded', String(Boolean(open)));
}));

const parseJod = (value) => {
  const cleaned = String(value || '').replace(/,/g, '').match(/[0-9]+(?:\.[0-9]+)?/);
  return cleaned ? Number(cleaned[0]) : 0;
};
const formatJod = (value) => `${Number(value || 0).toFixed(3)} د.أ`;

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const variantData = form.querySelector('[data-product-variants]');
  const variantInput = form.querySelector('[data-variant-id]');
  const submitButton = form.querySelector('[data-product-submit]');
  const priceElement = document.querySelector('[data-product-price]');
  const washDataElement = form.querySelector('[data-wash-service]');
  const weightSelect = form.querySelector('[data-weight-select]');
  const quantityInput = form.querySelector('input[name="quantity"]');
  if (!variantData || !variantInput || !submitButton) return;

  let variants = [];
  let washVariants = null;
  try { variants = JSON.parse(variantData.textContent); } catch (error) { return; }
  if (washDataElement) {
    try { washVariants = JSON.parse(washDataElement.textContent); } catch (error) { washVariants = null; }
  }

  const optionControls = [...form.querySelectorAll('[data-product-option]')]
    .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));

  const selectedValues = () => optionControls.map((control) => {
    if (control.matches('fieldset')) return control.querySelector('[data-option-value]:checked')?.value || '';
    return control.value;
  });

  const variantForValues = (values) => variants.find((variant) => variant.options.every((value, index) => value === values[index]));
  const selectedWashChoice = () => form.querySelector('[data-wash-choice]:checked')?.value || 'كما هو';
  const currentWash = () => washVariants?.[weightSelect?.value || ''] || null;

  const updatePreparationPrices = (values) => {
    form.querySelectorAll('fieldset[data-product-option]').forEach((fieldset) => {
      const position = Number(fieldset.dataset.optionPosition) - 1;
      fieldset.querySelectorAll('[data-option-value]').forEach((radio) => {
        const candidateValues = [...values];
        candidateValues[position] = radio.value;
        const candidate = variantForValues(candidateValues);
        const label = radio.closest('.service-option');
        const optionPrice = label?.querySelector('[data-option-price]');
        const unavailable = !candidate || !candidate.available;
        radio.disabled = unavailable;
        label?.classList.toggle('is-unavailable', unavailable);
        if (optionPrice) optionPrice.textContent = candidate ? candidate.price : '—';
      });
    });
  };

  const updateVariant = () => {
    const values = selectedValues();
    const variant = variantForValues(values);
    updatePreparationPrices(values);

    if (!variant) {
      submitButton.disabled = true;
      submitButton.textContent = 'هذا الخيار غير متوفر';
      return;
    }

    variantInput.value = variant.id;
    const wash = currentWash();
    const washed = selectedWashChoice() === 'مغسول';
    const surcharge = washed && wash ? Number(wash.amount || 0) : 0;
    const total = parseJod(variant.price) + surcharge;
    const displayPrice = surcharge > 0 ? formatJod(total) : variant.price;
    if (priceElement) priceElement.textContent = displayPrice;
    const washPrice = form.querySelector('[data-wash-price]');
    if (washPrice) washPrice.textContent = wash ? `+${formatJod(wash.amount)}` : '+0.000 د.أ';
    form.querySelectorAll('[data-base-service-price]').forEach((element) => { element.textContent = variant.price; });
    submitButton.disabled = !variant.available;
    submitButton.textContent = variant.available ? `أضف إلى السلة — ${displayPrice}` : 'غير متوفر حالياً';
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  optionControls.forEach((control) => control.addEventListener('change', updateVariant));
  form.querySelectorAll('[data-wash-choice]').forEach((control) => control.addEventListener('change', updateVariant));
  quantityInput?.addEventListener('change', updateVariant);
  updateVariant();

  if (washVariants) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const washChoice = selectedWashChoice();
      const wash = currentWash();
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const washLink = washChoice === 'مغسول' ? `wash-${Date.now()}-${Math.random().toString(36).slice(2, 9)}` : '';
      const productProperties = { 'طريقة الاستلام': washChoice };
      if (washLink) productProperties._wash_link = washLink;
      const items = [{ id: Number(variantInput.value), quantity, properties: productProperties }];
      if (washChoice === 'مغسول') {
        if (!wash?.id) { showToast('تعذر تحديد تكلفة الغسيل لهذا الوزن.'); return; }
        items.push({
          id: Number(wash.id),
          quantity,
          properties: {
            'الخدمة': 'غسيل',
            'للمنتج': form.dataset.productTitle || '',
            '_wash_link': washLink
          }
        });
      }
      submitButton.disabled = true;
      const oldText = submitButton.textContent;
      submitButton.textContent = 'جاري الإضافة...';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart');
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((element) => element.textContent = visibleCartItemCount(cart));
        showToast(washChoice === 'مغسول' ? 'تمت إضافة المنتج مع خدمة الغسيل' : 'تمت إضافة المنتج إلى السلة');
      } catch (error) {
        showToast('تعذر الإضافة. حاول مرة أخرى.');
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = oldText;
        updateVariant();
      }
    });
  }
});
